import { render } from "./GorusmebilgilerView.vue?vue&type=template&id=3e01d239"
import script from "./GorusmebilgilerView.vue?vue&type=script&lang=js"
export * from "./GorusmebilgilerView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__